export default "__VITE_ASSET__CjhGXkTE__"